import { PayloadAction } from "@reduxjs/toolkit";
import { ReduxHelper } from "helpers";
import { IBaseReducerState } from "helpers/reduxHelpers";
import { PrintActions } from "redux/actions";
interface IPrintState extends IBaseReducerState {}

const initialState: IPrintState = {
  action: PrintActions.prefix,
  prefix: PrintActions.prefix,
};

const clearReducer = (state: IPrintState, action: PayloadAction) =>
  ReduxHelper.handleReducerBuilder(state, action, () => {
    state.action = PrintActions.prefix;
  });

const reducer = ReduxHelper.createHandleReducer(initialState, (builder) => {
  builder.addCase(PrintActions.clearReducer.request, clearReducer);
});

export default reducer;
